import React, { useEffect, useState } from 'react'
import { useLoader } from '../../context/LoaderContext'
import { useModal } from '../../context/ModalContext'
import InputFormCe from '../../commons/Input/InputFormCe'
import ButtonCe from '../../commons/Button/ButtonCe'
import CreditCards from '../../assets/img/openpay_tarjetas_credito_02.png'
import * as Constants from '../../commons/Constants/Constants'
import * as UtilsOpenPay from "../../utils/openpay";
import * as Services from '../../services/Services';
import './MainView.scss'
import { LiferayProps } from '../..'


declare global {
  interface Window {
    grecaptcha: any;
  }
}

const loadRecaptchaScript = (siteKey: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    const existingScript = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement | null;

    if (existingScript) {
      const waitForGrecaptcha = () => {
        if (window.grecaptcha) {
          resolve();
        } else {
          setTimeout(waitForGrecaptcha, 200);
        }
      };

      waitForGrecaptcha();
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      const waitForGrecaptcha = () => {
        if (window.grecaptcha) {
          resolve();
        } else {
          setTimeout(waitForGrecaptcha, 200);
        }
      };

      waitForGrecaptcha();
    };

    script.onerror = () => {
      reject(new Error("No se pudo cargar reCAPTCHA"));
    };

    document.head.appendChild(script);
  });
};

const executeRecaptcha = (siteKey: string, action: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error("grecaptcha no está disponible"));
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(siteKey, { action })
        .then((token: string) => resolve(token))
        .catch((error: any) => reject(error));
    });
  });
};

const MainView: React.FC<LiferayProps> = ({ properties }) => {

  const { showLoader, hideLoader } = useLoader()
  const { showModal } = useModal()
  const [selectedIdAmount, setSelectedIdAmount] = useState<number | string>("0")
  const [valueAmountName, setNameAmountSelect] = useState('')
  const [valueAmountSelect, setAmountSelect] = useState(0)
  const [valueCustomizeAmount, setValueCustomizeAmount] = useState('')
  const [amountCents, setAmountCents] = useState<number>(0);
  const [dataMail, setDataMail] = useState('')
  const [dataName, setDataName] = useState('')
  const [dataNumberC, setDataNumberC] = useState('')
  const [dataNumberCNumber, setDataNumberCNumber] = useState('')
  const [dataMonthC, setDataMonthC] = useState('')
  const [dataYearC, setDatayearC] = useState('')
  const [codeC, setCodeC] = useState('')
  const [checkboxRecurring, setCheckboxRecurring] = useState(false)
  const [checkboxTerms, setCheckboxTerms] = useState(false)
  const [errorMsgAmount, setErrorMsgAmount] = useState('')
  const [errorMail, setErrorMail] = useState('')
  const [errorNumber, setErrorNumber] = useState('')
  const [errorCodeC, setErrorCodeC] = useState('')
  const [errorAmount, setErrorAmount] = useState('')
  const [errorMonth, setErrorMonth] = useState('')
  const [errorYear, setErrorYear] = useState('')
  const [errorPrivacy, setErrorPrivacy] = useState('')
  const [errorName, setErrorName] = useState('')
  const formRef = React.useRef<HTMLFormElement>(null)
  const [validMail, setValidMail] = useState(true)
  const [validName, setValidName] = useState(true)
  const [validNumberC, setValidNumberC] = useState(true)
  const [validCodeC, setValidCodeC] = useState(true)
  const [validAmount, setValidAmount] = useState(true)

  const currentYear = new Date().getFullYear()

  const handleAmountChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(e.target.value)
    setSelectedIdAmount(id)
    const selectedOption = Constants.AMOUNT_OPTIONS.find(
      option => option.id === id
    )
    if (selectedOption) {
      setNameAmountSelect(selectedOption.name)
      setAmountSelect(selectedOption.amount)
    }
  }
  const handleMailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDataMail(e.target.value)
  }
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.value;
    if (/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*$/.test(name)) {
      setDataName(name)
    }
  }
  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDataNumberC(formatCardNumber(e.target.value))
    setDataNumberCNumber(onlyDigits(e.target.value))
  }
  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDataMonthC(e.target.value)
  }
  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDatayearC(e.target.value)
  }
  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value;
    setCodeC(code.replace(/\D/g, "").slice(0, 3))
  }
  const handleCheckboxRecurringChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxRecurring(e.target.checked);
  }
  const handleCheckboxTermsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxTerms(e.target.checked);
  }
  const handleCustomizeAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const amount = value.replace(/\D/g, "");
    setAmountCents(amount === "" ? 0 : parseInt(amount, 10));
    setValueCustomizeAmount(formatAmount(amount))
  }
  const isValidEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const formatCardNumber = (value: string): string => {
    const digits = value.replace(/\D/g, "");
    return digits.replace(/(.{4})/g, "$1-").replace(/-$/, "");
  };
  const onlyDigits = (card: string): string => {
    return card.replace(/\D/g, '');
  }
  const handleAmountBlur = () => {
    if (selectedIdAmount == 0) {
      setErrorAmount("Selecciona una opción")
    } else {
      setErrorAmount("")
    }
  };
  const handleMonthBlur = () => {
    if (dataMonthC == "") {
      setErrorMonth("Selecciona el mes")
    } else {
      setErrorMonth("")
    }
  };
  const handleYearBlur = () => {
    if (dataYearC == "") {
      setErrorYear("Selecciona el año")
    } else {
      setErrorYear("")
    }
  };

  useEffect(() => {
    if (amountCents <= 1000 * 100) {
      setErrorMsgAmount("El monto debe ser mayor a $1000.00")
    } else if (amountCents >= 100000 * 100) {
      setErrorMsgAmount("El monto no puede ser mayor a $99,999.99")
    } else if (valueCustomizeAmount == "") {
      setErrorMsgAmount("Completa este campo")
    } else {
      setErrorMsgAmount("")
    }
  }, [valueCustomizeAmount])

  useEffect(() => {
    if (dataMail == "") {
      setErrorMail("Completa este campo")
    } else if (!isValidEmail(dataMail)) {
      setErrorMail("Introduce un correo válido")
    } else {
      setErrorMail("")
    }
  }, [dataMail])

  useEffect(() => {
    if (dataNumberC == "") {
      setErrorNumber("Completa este campo")
    } else if (dataNumberC.length < 19) {
      setErrorNumber("Ingresa los 16 números de la tarjeta")
    } else {
      setErrorNumber("")
    }
  }, [dataNumberC])

  useEffect(() => {
    if (dataName == "") {
      setErrorName("Completa este campo")
    } else {
      setErrorName("")
    }
  }, [dataName])

  useEffect(() => {
    if (codeC == "") {
      setErrorCodeC("Completa este campo")
    } else if (codeC.length < 3) {
      setErrorCodeC("Ingresa los 3 dígitos")
    } else {
      setErrorCodeC("")
    }
  }, [codeC])

  useEffect(() => {
    if (dataMonthC !== "") {
      setErrorMonth("")
    }
  }, [dataMonthC])

  useEffect(() => {
    if (dataYearC !== "") {
      setErrorYear("")
    }
  }, [dataYearC])

  useEffect(() => {
    const initRecaptcha = async () => {
      try {
        if (properties?.recaptchaSiteKey) {
          await loadRecaptchaScript(properties.recaptchaSiteKey);
        }
      } catch (error) {
        console.error("Error cargando reCAPTCHA", error);
      }
    };

    initRecaptcha();
  }, [properties?.recaptchaSiteKey]);

  useEffect(() => {
    if (selectedIdAmount !== 0) {
      setErrorAmount("")
    } else {
      setErrorAmount("Selecciona una opción")
    }
  }, [selectedIdAmount])

  useEffect(() => {
    if (checkboxTerms == true) {
      setErrorPrivacy("")
    }
  }, [checkboxTerms])

  const formatAmount = (digits: string) => {
    const padded = digits.padStart(3, "0");
    const intPart = padded.slice(0, -2);
    const dec = padded.slice(-2);
    const withThousands = Number(intPart).toLocaleString("es-MX");
    return `${withThousands}.${dec}`;
  };

  const validateMail = () => {
    const ok = dataMail !== '' && isValidEmail(dataMail)
    setValidMail(ok)
    return ok
  }
  const validateName = () => {
    const ok = dataName !== ''
    setValidName(ok)
    return ok
  }
  const validateNumberC = () => {
    const ok = dataNumberC !== '' && dataNumberC.length == 19
    setValidNumberC(ok)
    return ok
  }
  const validateCodeC = () => {
    const ok = codeC !== '' && codeC.length == 3
    setValidCodeC(ok)
    return ok
  }
  const validateAmount = () => {
    const ok =
      (selectedIdAmount === 9999 && valueCustomizeAmount !== '' && (amountCents < 100000 * 100) && (amountCents > 1000 * 100)) ||
      (selectedIdAmount !== 9999 && selectedIdAmount !== 0)
    setValidAmount(ok)
    return ok
  }
  const cleanForm = () => {
    setSelectedIdAmount(0)
    setDataMail("")
    setDataName("")
    setValueCustomizeAmount("")
    setDataNumberC("")
    setDataMonthC("")
    setDatayearC("")
    setCodeC("")
    setCheckboxRecurring(false)
    setCheckboxTerms(false)
  }

  const OP_BASE = properties.urlOpenPay!;
  const OP_ID = properties.idMerchantOpenPay!;
  const OP_KEY = properties.keytMerchantOpenPay!;
  const OP_SANBOX = properties.sandboxOpenPay == "true" ? true : false;

  const handlePay: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();

    if (selectedIdAmount == 0) {
      setErrorAmount("Selecciona una opción")
      return;
    }

    const okAmount = validateAmount();
    const okMail = validateMail();
    const okName = validateName();
    const okNumberC = validateNumberC();
    const okCodeC = validateCodeC();

    if (!okAmount || !okMail || !okName || !okNumberC || !okCodeC) {
      return;
    }


    if (dataMonthC == "") {
      setErrorMonth("Selecciona el mes")
      return;
    }

    if (dataYearC == "") {
      setErrorYear("Selecciona el año")
      return;
    }

    if (checkboxTerms == false) {
      setErrorPrivacy("Campo obligatorio")
      return;
    }

    showLoader();
    try {
      const siteKey = properties?.recaptchaSiteKey;

      if (!siteKey) {
        throw new Error("No se encontró la site key de reCAPTCHA");
      }

      const recaptchaToken = await executeRecaptcha(siteKey, "donation_submit");

      if (!recaptchaToken) {
        throw new Error("No fue posible validar reCAPTCHA");
      }

      await UtilsOpenPay.ensureOpenpayScripts();
      UtilsOpenPay.initOpenpay({
        merchantId: OP_ID,
        publicKey: OP_KEY,
        sandbox: OP_SANBOX,
      });

      const deviceSessionId = UtilsOpenPay.getDeviceSessionId(formRef.current!);

      const tokenOP = await UtilsOpenPay.createCardToken({
        card_number: dataNumberCNumber,
        holder_name: dataName,
        expiration_year: dataYearC.slice(-2),
        expiration_month: dataMonthC,
        cvv2: codeC,
      });

      const accessToken = await Services.getToken();

      const headers = {
        xUserAgent: "X-User-Agent",
        cognitoClient: "cognito-client",
        Authorization: `Bearer ${accessToken}`
      };

      const body: Services.CreateCardBody = {
        countryId: 1,
        name: dataName,
        email: dataMail,
        card: {
          "tokenId": tokenOP.id,
          "deviceSessionId": deviceSessionId
        },
        captchaToken:recaptchaToken
      };
      const cardRes = await Services.createCard(
        OP_BASE, body, headers
      );

      const cardId = cardRes.content?.cardId ?? 0;

      const charge = await Services.createChargeByCardId(
        OP_BASE,
        cardId,
        {
          "deviceSessionId": deviceSessionId,
          amount: valueAmountName == "Otra cantidad" ? Number(amountCents / 100) : valueAmountSelect,
          isRecurrent: checkboxRecurring,
          periodicity: checkboxRecurring === true ? "month" : "year"
        },
        headers
      );

      if (charge?.status === "200 OK") {
        hideLoader();
        const invoiceFailed = charge.content?.invoiceStatus === "FAILED";
        const emailFailed = charge.content?.emailStatus === "FAILED";
        let textModal = "Tu pago fue procesado correctamente.";
        if (invoiceFailed) {
          textModal = "Tu pago fue procesado correctamente, pero no pudimos generar la factura, comunicate a fundacion@alsea.net para ayudarte";
        } else if (emailFailed) {
          textModal = "Tu pago se procesó correctamente, pero no pudimos enviar el correo de confirmación, comunicate a fundacion@alsea.net para ayudarte";
        }
        showModal({
          titleModal: "Donación exitosa",
          textModal,
          primaryBtn: false,
          secondaryBtn: false
        });
        cleanForm();
        return;
      }

    } catch (err: any) {
      if (
        err?.message === "No se encontró la site key de reCAPTCHA" ||
        err?.message === "No fue posible validar reCAPTCHA" ||
        err?.message === "grecaptcha no está disponible"
      ) {
        showModal({
          titleModal: "Validación requerida",
          textModal: "No fue posible validar reCAPTCHA. Intenta nuevamente.",
          primaryBtn: false,
          secondaryBtn: false
        });
      } else if (err.status === 422 || err.status === 400) {
        showModal({
          titleModal: "Datos incorrectos",
          textModal: "Revisa los datos de pago",
          primaryBtn: false,
          secondaryBtn: false
        })
      } else {
        showModal({
          titleModal: "Lo sentimos, ocurrió un error al procesar tu solicitud.",
          textModal: "El cargo no fue realizado",
          primaryBtn: false,
          secondaryBtn: false
        })
      }
    } finally {
      hideLoader();
    }
  };

  const handleReceipt = () => {
    window.location.href = "https://alseadonativos.interfactura.com/RegistroDocumento.aspx";
  }

  return (
    <>
      <main className='ce-openpay-form-container'>
        <h1
          className='ce-openpay-form-container__title font-60 orange animated pt-20-mobile fadeInDown visible pluto'
          data-animation="fadeInDown"
          data-animation-delay="400"
        >
          ¡Dona ahora!
        </h1>
        <p
          className='ce-openpay-form-container__paragraph font-26 t-center lh-40 animated mt-20 horange xxs-px-mobile vxmc_color_blue fadeInDown visible pluto'
          data-animation="fadeInDown"
          data-animation-delay="400"
        >
          Te invitamos a donar ahora
          <br />
          <br />
          AYÚDANOS A CONSTRUIR UN PAÍS DONDE SUS NIÑOS SOLO TENGAN HAMBRE DE CRECER, APRENDER Y COMPARTIR.
        </p>
        <p className='ce-openpay-form-container__paragraph font-26 t-center lh-40 animated mt-20 xxs-px-mobile vxmc_color_blue fadeInUp visible pluto'
          data-animation="fadeInUp"
          data-animation-delay="400"
        >
          Juntos lo haremos realidad.
        </p>
        <form className='ce-openpay-form-container__form-section row oswald400 uppercase mt-40 container-sm sm-px bg-gray radius-md sm-px xxs-px-mobile' ref={formRef}>
          <div className='ce-openpay-form-container__select-amount col-md-6 col-sm-12 col-xs-12'>
            <label className="font-16 vxmc_color_blue">Monto a donar *</label>
            <select
              value={selectedIdAmount}
              onChange={handleAmountChange}
              id="monto"
              className='ce-openpay-form-container__select ce-openpay-form-container__select--amount amountC vxmc_color_blue'
              onBlur={handleAmountBlur}
            >
              <option value="0">Selecciona el monto</option>
              {Constants.AMOUNT_OPTIONS.map((option, index) =>
                <option
                  key={index}
                  value={option.id}
                >
                  {option.name}
                </option>
              )}
            </select>
            {(errorAmount !== "") ?
              <div role="alert" aria-live="assertive" className='ce-als-input__error-msg' id='ce-input-error-monto'>
                <p className=''>* {errorAmount}</p>
              </div>
              : null
            }
          </div>
          {
            valueAmountName == "Otra cantidad" ?
              <>
                <InputFormCe
                  labelInput='OTRA CANTIDAD'
                  placeholderInput='5000.00'
                  typeInput='text'
                  idInput='ce-input-form-customize-amount'
                  maxLenghtInput={20}
                  onChange={handleCustomizeAmountChange}
                  onBlur={validateAmount}
                  valueInserted={valueCustomizeAmount}
                  isValid={validAmount}
                  nameInput='Amount'
                  errorText={errorMsgAmount}
                  required={true}
                  styleCustomize='col-md-6 col-sm-12 col-xs-12'
                />
              </> : null
          }
          <InputFormCe
            labelInput='CORREO ELECTRÓNICO'
            placeholderInput='CORREO ELECTRÓNICO'
            typeInput='text'
            idInput='ce-input-form-mail'
            maxLenghtInput={50}
            onChange={handleMailChange}
            onBlur={validateMail}
            valueInserted={dataMail}
            isValid={validMail}
            nameInput='Mail'
            errorText={errorMail}
            required={true}
            styleCustomize='col-md-6 col-sm-12 col-xs-12'
          />
          <InputFormCe
            labelInput='DATOS DE LA TARJETA'
            placeholderInput='Nombre del titular'
            typeInput='text'
            idInput='ce-input-form-name'
            maxLenghtInput={80}
            onChange={handleNameChange}
            onBlur={validateName}
            valueInserted={dataName}
            isValid={validName}
            nameInput='Name'
            errorText={errorName}
            required={true}
            styleCustomize='col-md-6 col-sm-12 col-xs-12'
          />
          <InputFormCe
            labelInput='NÚMERO DE LA TARJETA'
            placeholderInput='NÚMERO DE LA TARJETA'
            typeInput='text'
            idInput='ce-input-form-card'
            maxLenghtInput={19}
            onChange={handleNumberChange}
            onBlur={validateNumberC}
            valueInserted={dataNumberC}
            isValid={validNumberC}
            nameInput='Card'
            errorText={errorNumber}
            required={true}
            styleCustomize='col-md-6 col-sm-12 col-xs-12'
          />
          <div className='ce-openpay-form-container__select-expiration-date col-md-12 col-sm-12'>
            <div className='row'>
              <div className='col-md-6 col-sm-12'>
                <div className='row'>
                  <div className='col-md-12 col-sm-12'>
                    <label className="font-16 vxmc_color_blue">Fecha de expiración *</label>
                  </div>
                  <div className='col-md-6 col-sm-12' onBlur={handleMonthBlur}>
                    <select
                      value={dataMonthC}
                      onChange={handleMonthChange}
                      className="ce-openpay-form-container__select amountC vxmc_color_blue">
                      <option disabled value="">MM</option>
                      {Constants.MONTH_OPTIONS.map((option, index) =>
                        <option
                          key={index}
                          value={option.name}>
                          {option.name}
                        </option>
                      )}
                    </select>
                    {(errorMonth !== "") ?
                      <div role="alert" aria-live="assertive" className='ce-als-input__error-msg' id='ce-input-error-month'>
                        <p className=''>* {errorMonth}</p>
                      </div>
                      : null
                    }
                  </div>
                  <div className='col-md-6 col-sm-12' onBlur={handleYearBlur}>
                    <select
                      value={dataYearC}
                      onChange={handleYearChange}
                      className="ce-openpay-form-container__select amountC vxmc_color_blue">
                      <option disabled value="">AAAA</option>
                      {Array.from({ length: 11 }, (_, index) => {
                        const year = currentYear + index;
                        return (
                          <option
                            key={year}
                            value={String(year)}
                          >
                            {year}
                          </option>
                        );
                      })}
                    </select>
                    {(errorYear !== "") ?
                      <div role="alert" aria-live="assertive" className='ce-als-input__error-msg' id='ce-input-error-year'>
                        <p className=''>* {errorYear}</p>
                      </div>
                      : null
                    }
                  </div>
                </div>
              </div>
              <div className='ce-openpay-form-container__input-code col-md-6 col-sm-12 row'>
                <InputFormCe
                  labelInput='Código de seguridad'
                  placeholderInput='3 DIGITOS'
                  typeInput='password'
                  idInput='ce-input-form-code'
                  maxLenghtInput={3}
                  onChange={handleCodeChange}
                  valueInserted={codeC}
                  isValid={validCodeC}
                  nameInput='Code'
                  errorText={errorCodeC}
                  required={true}
                  styleCustomize='col-sm-12 col-xs-12'
                />
              </div>
            </div>
          </div>
          <div className="ce-openpay-form-container__checkbox-options col-md-12 col-sm-12">
            <div className="w-100 f-left font-15">
              <label className="contbox pl-30 vxmc_color_blue">Deseo donar un <b>cargo recurrente mensual</b>.
                <input
                  type="checkbox"
                  id="recurrent"
                  name="recurrent"
                  value="1"
                  checked={checkboxRecurring}
                  onChange={handleCheckboxRecurringChange}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="w-100 f-left font-15">
              <label className="contbox pl-30 vxmc_color_blue">He leído y acepto el <a target="_blank" className="orange" href="/web/va-por-mi-cuenta/aviso-de-privacidad">aviso de privacidad</a> *
                <input
                  type="checkbox"
                  checked={checkboxTerms}
                  id="privacy"
                  name="privacy"
                  value="1"
                  required
                  onChange={handleCheckboxTermsChange}
                />
                <span className="checkmark"></span>
                {(errorPrivacy !== "") ?
                  <div role="alert" aria-live="assertive" className='ce-als-input__error-msg' id='ce-input-error-privacy'>
                    <p className=''>* {errorPrivacy}</p>
                  </div>
                  : null
                }
              </label>
              <div className="ce-openpay-form-container__recaptcha-note col-md-12 col-sm-12">
  <p className="font-12 vxmc_color_blue mt-2">
    Este sitio está protegido por reCAPTCHA y aplican la
    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="orange">
      {" "}Política de Privacidad
    </a>
    {" "}y los
    <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" className="orange">
      {" "}Términos del Servicio
    </a>
    {" "}de Google.
  </p>
</div>

            </div>
          </div>
          <div className='col-md-12 col-sm-12 mt-40'>
            <ButtonCe
              styleCustomize='ce-openpay-form-container__bottom-submit w-100-mobile radius-20 orange-bg xl-btn slow click-effect white oswald400 qdr-hover-6 font-22 uppercase bs-hover'
              txtButton='Donar'
              disabledButton={false}
              onClick={handlePay}
            />
          </div>
          <div className='ce-openpay-form-container__credit-cards oswald400'>
            <div className='w-auto w-100-mobile mr-50 t-center no-margin-mobile'>
              <p className='vxmc_color_blue'>TARJETAS DE CRÉDITO Y DÉBITO</p>
              <img src={CreditCards} alt="Tarjetas de crédito disponibles" />
            </div>
          </div>
        </form>
        <div className='ce-openpay-form-container__bottom-section container-sm pt-20 pb-20 uppercase  t-center mt-40 mb-40'>
          <div className='mt-0 animated fadeInUp visible'>
            <ButtonCe
              styleCustomize='ce-openpay-form-container__bottom-btn deduce width-auto click-effect qdr-hover-6 oswald400 radius-20 bs-hover'
              txtButton='Obtén recibo deducible'
              disabledButton={false}
              onClick={handleReceipt}
            />
          </div>
        </div>
      </main>
    </>
  )
}

export default MainView